var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"w-1200 clearfix"},[_c('expertMembers'),_c('router-view',{key:_vm.$route.fullPath})],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }